import tempMeeApi from '../../../apis/tempMee';

// GOTU-5626 follow-up: the single-cycle read the detail screen needs. The list
// cannot serve it — it is paginated with no id filter and no way to ask which
// page holds a given cycle. Returns 404 for an unknown id.
export const getCycle = async (cycleId) => {
  const response = await tempMeeApi.get(
    `/awards-service-api/admin/cycles/${cycleId}`,
  );

  return response.data;
};
